import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import conf from "./../../../config.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import Select from "react-select";
import SweetAlert from "sweetalert2-react";
import Skeleton from "react-loading-skeleton";

// Custom select styles - disamakan dengan TambahSiswaKeRombel.js
const selectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    borderRadius: "12px",
    minWidth: "12rem",
    border: isFocused ? "2px solid #6366f1" : "1px solid #e5e7eb",
    boxShadow: isFocused ? "0 0 0 3px rgba(99, 102, 241, 0.1)" : "none",
    "&:hover": {
      borderColor: "#6366f1",
    },
  }),
  option: (styles, { isSelected, isFocused }) => ({
    ...styles,
    backgroundColor: isSelected ? "#6366f1" : isFocused ? "#eef2ff" : "white",
    color: isSelected ? "white" : "#1f2937",
  }),
};

const dataKurikulum = [
  { value: "k13", label: "K13" },
  { value: "merdeka", label: "Merdeka" },
];

export default class OrangtuaRombel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // ============ URLs ============
      url: `${conf.uri_backend}api/v1/rombel/orangtua`,
      url_get_rombel: `${conf.uri_backend}api/v1/rombel/get_rombel`,
      url_get_spektrum: `${conf.uri_backend}api/v1/rombel/get_spektrum`,
      url_get_smk: `${conf.uri_backend}api/v1/referensi/struktur-kurikulum`,
      url_show_data: "",
      query: "",

      // ============ Session & Institution ============
      data_session: null,
      institusi_id_select: null,
      jenjang_id_select: null,
      tahunSekarang: new Date().getFullYear(),

      // ============ Alert ============
      show_alert: false,
      title_alert: "",
      message_alert: "",
      icon_alert: "",

      // ============ Filter values ============
      tahun_ajaran_search: "",
      filterKurikulumSearch: "",
      kelas_search: "",
      peminatan_search: "",
      peminatan_search_label: "",
      bidang_search: "",
      bidang_search_label: "",
      program_search: "",
      program_search_label: "",
      kompetensi_search: "",
      kompetensi_search_label: "",
      rombel_search: "",
      rombel_search_label: "",
      searchText: "",

      // ============ Filter data options ============
      data_tahun_ajaran: [],
      data_kelas: [],
      data_peminatan: [],
      data_bidang: [],
      data_program: [],
      data_kompetensi: [],
      data_rombel: [],

      // ============ Loading states ============
      loadingFilter: true,
      loading_peminatan: false,
      loading_bidang: false,
      loading_program: false,
      loading_kompetensi: false,
      loading_rombel: false,
      loadingSearch: false,
    };

    // get option filter
    this.getTahunAjaranNow = this.getTahunAjaranNow.bind(this);
    this.getKelas = this.getKelas.bind(this);
    this.getPeminatanSMA = this.getPeminatanSMA.bind(this);
    this.getBidang = this.getBidang.bind(this);
    this.getProgram = this.getProgram.bind(this);
    this.getKompetensi = this.getKompetensi.bind(this);
    this.getRombel = this.getRombel.bind(this);

    // filter handlers
    this.filterTahunAjaran = this.filterTahunAjaran.bind(this);
    this.filterKurikulum = this.filterKurikulum.bind(this);
    this.filterKelas = this.filterKelas.bind(this);
    this.filterPeminatan = this.filterPeminatan.bind(this);
    this.filterBidang = this.filterBidang.bind(this);
    this.filterProgram = this.filterProgram.bind(this);
    this.filterKompetensi = this.filterKompetensi.bind(this);
    this.filterRombel = this.filterRombel.bind(this);

    // search & filter actions
    this.setFilter = this.setFilter.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.handleSearch = this.handleSearch.bind(this);

    // render
    this.renderFilterPanel = this.renderFilterPanel.bind(this);
    this.renderSMKFilters = this.renderSMKFilters.bind(this);
    this.showData = this.showData.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem("token") !== null) {
      axios
        .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.setState({ data_session: res.data }, () => {
            axios
              .get(
                `${conf.uri_backend}api/v1/select-institusi/${this.state.data_session.access_to}`,
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                this.setState(
                  {
                    institusi_id_select: res.data.id,
                    jenjang_id_select: res.data.m_struktur_jenjang_id,
                    url_show_data: `${this.state.url}`,
                    query: "&institusi_id=" + res.data.id,
                  },
                  () => {
                    this.loadInitialData();
                  }
                );
              });
          });
        });
    }
  }

  loadInitialData() {
    this.getTahunAjaranNow();
    this.getKelas();
    this.loadSavedFilter();
  }

  // ============ SAVED FILTER (localStorage) - sama seperti TambahSiswaKeRombel.js ============
  getFilterStorageKey() {
    return `rombel_filter_orangtua_${this.state.institusi_id_select}`;
  }

  loadSavedFilter() {
    try {
      const savedFilter = localStorage.getItem(this.getFilterStorageKey());
      if (savedFilter) {
        const filter = JSON.parse(savedFilter);
        this.setState(
          {
            tahun_ajaran_search: filter.tahun_ajaran || "",
            kelas_search: filter.kelas || "",
            filterKurikulumSearch: filter.kurikulum || "",
            bidang_search: filter.bidang_id || "",
            bidang_search_label: filter.bidang_label || "",
            program_search: filter.program_id || "",
            program_search_label: filter.program_label || "",
            kompetensi_search: filter.kompetensi_id || "",
            kompetensi_search_label: filter.kompetensi_label || "",
            peminatan_search: filter.peminatan_id || "",
            peminatan_search_label: filter.peminatan_label || "",
            rombel_search: filter.rombel_id || "",
            rombel_search_label: filter.rombel_label || "",
            loadingFilter: false,
          },
          () => {
            if (this.state.filterKurikulumSearch) {
              this.getPeminatanSMA();
              this.getBidang();
            }
            // Filter tersimpan langsung diterapkan ke tabel
            this.setFilter(true);
          }
        );
      } else {
        // Belum ada filter tersimpan -> tetap load semua data orang tua
        // milik institusi ini (tanpa filter tambahan apapun), supaya
        // halaman langsung menampilkan data begitu dibuka.
        this.setState({ loadingFilter: false }, () => {
          this.setFilter(true);
        });
      }
    } catch (e) {
      console.warn("Failed to load saved filter:", e);
      this.setState({ loadingFilter: false }, () => {
        this.setFilter(true);
      });
    }
  }

  saveFilterToStorage() {
    const filter = {
      tahun_ajaran: this.state.tahun_ajaran_search,
      kelas: this.state.kelas_search,
      kurikulum: this.state.filterKurikulumSearch,
      bidang_id: this.state.bidang_search,
      bidang_label: this.state.bidang_search_label,
      program_id: this.state.program_search,
      program_label: this.state.program_search_label,
      kompetensi_id: this.state.kompetensi_search,
      kompetensi_label: this.state.kompetensi_search_label,
      peminatan_id: this.state.peminatan_search,
      peminatan_label: this.state.peminatan_search_label,
      rombel_id: this.state.rombel_search,
      rombel_label: this.state.rombel_search_label,
      savedAt: new Date().toISOString(),
    };
    try {
      localStorage.setItem(this.getFilterStorageKey(), JSON.stringify(filter));
    } catch (e) {
      console.warn("Failed to save filter:", e);
    }
  }

  clearSavedFilter() {
    try {
      localStorage.removeItem(this.getFilterStorageKey());
    } catch (e) {
      console.warn("Failed to clear filter:", e);
    }
  }

  // ============ FILTER DATA GETTERS - disamakan dengan TambahSiswaKeRombel.js ============
  getTahunAjaranNow() {
    const ta = [];
    const tahunSekarang = this.state.tahunSekarang + 1;
    for (let i = tahunSekarang; i >= 2005; i--) {
      ta.push({ value: `${i - 1} / ${i}`, label: `${i - 1} / ${i}` });
    }
    this.setState({ data_tahun_ajaran: ta });
  }

  getKelas() {
    let kelas = [];
    const jenjang = String(this.state.jenjang_id_select);

    if (jenjang === "2") {
      kelas = [
        { value: "I", label: "I" },
        { value: "II", label: "II" },
        { value: "III", label: "III" },
        { value: "IV", label: "IV" },
        { value: "V", label: "V" },
        { value: "VI", label: "VI" },
      ];
    } else if (jenjang === "3") {
      kelas = [
        { value: "VII", label: "VII" },
        { value: "VIII", label: "VIII" },
        { value: "IX", label: "IX" },
      ];
    } else if (jenjang === "4" || jenjang === "5") {
      kelas = [
        { value: "X", label: "X" },
        { value: "XI", label: "XI" },
        { value: "XII", label: "XII" },
      ];
      if (jenjang === "5") {
        kelas.push({ value: "XIII", label: "XIII" });
      }
    }
    this.setState({ data_kelas: kelas, loadingFilter: false });
  }

  getPeminatanSMA() {
    if (String(this.state.jenjang_id_select) === "4") {
      this.setState({ loading_peminatan: true });
      const kurikulum = this.state.filterKurikulumSearch || "k13";
      axios
        .get(
          `${this.state.url_get_spektrum}?jenjang=${this.state.jenjang_id_select}&kurikulum=${kurikulum}`,
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({
            data_peminatan: res.data.status ? res.data.data : [],
            loading_peminatan: false,
          });
        })
        .catch(() => {
          this.setState({ loading_peminatan: false });
        });
    }
  }

  getBidang() {
    if (String(this.state.jenjang_id_select) === "5") {
      this.setState({ loading_bidang: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=0&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({ data_bidang: res.data, loading_bidang: false });
        })
        .catch(() => {
          this.setState({ loading_bidang: false });
        });
    }
  }

  getProgram() {
    if (
      String(this.state.jenjang_id_select) === "5" &&
      this.state.bidang_search
    ) {
      this.setState({ loading_program: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.bidang_search}&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({ data_program: res.data, loading_program: false });
        })
        .catch(() => {
          this.setState({ loading_program: false });
        });
    }
  }

  getKompetensi() {
    if (
      String(this.state.jenjang_id_select) === "5" &&
      this.state.program_search &&
      this.state.filterKurikulumSearch === "k13"
    ) {
      this.setState({ loading_kompetensi: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.program_search}&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({
            data_kompetensi: res.data,
            loading_kompetensi: false,
          });
        })
        .catch(() => {
          this.setState({ loading_kompetensi: false });
        });
    }
  }

  getRombel() {
    const peminatan =
      String(this.state.jenjang_id_select) === "5"
        ? this.state.kompetensi_search
        : this.state.peminatan_search;
    const kurikulum = this.state.filterKurikulumSearch || "";

    this.setState({ loading_rombel: true });
    axios
      .get(
        `${this.state.url_get_rombel}?tahun_ajaran=${this.state.tahun_ajaran_search}&kelas=${this.state.kelas_search}&peminatan=${peminatan}&user_institusi_id=${this.state.institusi_id_select}&kurikulum=${kurikulum}&program_id=${this.state.program_search}&bidang_id=${this.state.bidang_search}`,
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ data_rombel: res.data, loading_rombel: false });
      })
      .catch(() => {
        this.setState({ loading_rombel: false });
      });
  }

  // ============ FILTER HANDLERS - cascading reset, disamakan dengan TambahSiswaKeRombel.js ============
  filterTahunAjaran(e) {
    if (e) {
      this.setState({ tahun_ajaran_search: e.value }, () => {
        if (this.state.kelas_search) {
          this.getRombel();
        }
      });
    } else {
      this.setState({ tahun_ajaran_search: "" });
    }
  }

  filterKurikulum(e) {
    if (e) {
      this.setState(
        {
          filterKurikulumSearch: e.value,
          peminatan_search: "",
          peminatan_search_label: "",
          bidang_search: "",
          bidang_search_label: "",
          program_search: "",
          program_search_label: "",
          kompetensi_search: "",
          kompetensi_search_label: "",
          rombel_search: "",
          rombel_search_label: "",
          data_peminatan: [],
          data_bidang: [],
          data_program: [],
          data_kompetensi: [],
          data_rombel: [],
        },
        () => {
          this.getPeminatanSMA();
          this.getBidang();
        }
      );
    } else {
      this.setState({ filterKurikulumSearch: "" });
    }
  }

  filterKelas(e) {
    if (e) {
      this.setState(
        {
          kelas_search: e.value,
          peminatan_search: "",
          peminatan_search_label: "",
          bidang_search: "",
          bidang_search_label: "",
          program_search: "",
          program_search_label: "",
          kompetensi_search: "",
          kompetensi_search_label: "",
          rombel_search: "",
          rombel_search_label: "",
          data_rombel: [],
        },
        () => {
          this.getRombel();
        }
      );
    } else {
      this.setState({
        kelas_search: "",
        peminatan_search: "",
        bidang_search: "",
        program_search: "",
        kompetensi_search: "",
        rombel_search: "",
        rombel_search_label: "",
        data_rombel: [],
      });
    }
  }

  filterPeminatan(e) {
    if (e) {
      this.setState(
        {
          peminatan_search: e.value,
          peminatan_search_label: e.label,
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          this.getRombel();
        }
      );
    } else {
      this.setState({
        peminatan_search: "",
        peminatan_search_label: "",
        rombel_search: "",
      });
    }
  }

  filterBidang(e) {
    if (e) {
      this.setState(
        {
          bidang_search: e.value,
          bidang_search_label: e.label,
          program_search: "",
          program_search_label: "",
          kompetensi_search: "",
          kompetensi_search_label: "",
          data_program: [],
          data_kompetensi: [],
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          this.getProgram();
        }
      );
    } else {
      this.setState({
        bidang_search: "",
        bidang_search_label: "",
        program_search: "",
        program_search_label: "",
        kompetensi_search: "",
        kompetensi_search_label: "",
        data_program: [],
        data_kompetensi: [],
      });
    }
  }

  filterProgram(e) {
    if (e) {
      this.setState(
        {
          program_search: e.value,
          program_search_label: e.label,
          kompetensi_search: "",
          kompetensi_search_label: "",
          data_kompetensi: [],
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          if (this.state.filterKurikulumSearch === "k13") {
            this.getKompetensi();
          } else {
            this.getRombel();
          }
        }
      );
    } else {
      this.setState({
        program_search: "",
        program_search_label: "",
        kompetensi_search: "",
        kompetensi_search_label: "",
        data_kompetensi: [],
      });
    }
  }

  filterKompetensi(e) {
    if (e) {
      this.setState(
        {
          kompetensi_search: e.value,
          kompetensi_search_label: e.label,
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          this.getRombel();
        }
      );
    } else {
      this.setState({ kompetensi_search: "", kompetensi_search_label: "" });
    }
  }

  filterRombel(e) {
    if (e) {
      this.setState({ rombel_search: e.value, rombel_search_label: e.label });
    } else {
      this.setState({ rombel_search: "", rombel_search_label: "" });
    }
  }

  // ============ SEARCH / FILTER ACTIONS ============
  // Sama seperti HistoriRombel.js: tombol Cari tetap aktif walau baru
  // sebagian filter yang dipilih, karena ini halaman telusuri/browse,
  // bukan halaman "pilih rombel tujuan" seperti TambahSiswaKeRombel.
  setFilter(resetSelection = true) {
    this.saveFilterToStorage();

    const peminatan =
      String(this.state.jenjang_id_select) === "5"
        ? this.state.kompetensi_search
        : this.state.peminatan_search;

    const query =
      "&institusi_id=" +
      this.state.institusi_id_select +
      "&query=" +
      this.state.searchText +
      "&m_spektrum_id=" +
      peminatan +
      "&rombel_id=" +
      this.state.rombel_search +
      "&tahun_ajaran=" +
      this.state.tahun_ajaran_search +
      "&kurikulum=" +
      this.state.filterKurikulumSearch +
      "&kelas=" +
      this.state.kelas_search;

    this.setState({ query, loadingSearch: false }, () => {
      if (this.dt) {
        this.dt.loading();
        this.dt.resetPage(this.state.query);
      }
    });
  }

  resetFilters() {
    this.clearSavedFilter();
    this.setState(
      {
        tahun_ajaran_search: "",
        filterKurikulumSearch: "",
        kelas_search: "",
        peminatan_search: "",
        peminatan_search_label: "",
        bidang_search: "",
        bidang_search_label: "",
        program_search: "",
        program_search_label: "",
        kompetensi_search: "",
        kompetensi_search_label: "",
        rombel_search: "",
        rombel_search_label: "",
        searchText: "",
        data_peminatan: [],
        data_bidang: [],
        data_program: [],
        data_kompetensi: [],
        data_rombel: [],
      },
      () => {
        this.setFilter();
      }
    );
  }

  handleSearch(e) {
    const searchText = e.target.value;
    this.setState({ searchText }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.setFilter(false);
      }, 300);
    });
  }

  // ============ RENDER: FILTER PANEL - disamakan dengan TambahSiswaKeRombel.js ============
  renderFilterPanel() {
    const anyFilterSelected =
      this.state.tahun_ajaran_search !== "" ||
      this.state.filterKurikulumSearch !== "" ||
      this.state.kelas_search !== "" ||
      this.state.peminatan_search !== "" ||
      this.state.bidang_search !== "" ||
      this.state.program_search !== "" ||
      this.state.kompetensi_search !== "" ||
      this.state.rombel_search !== "";

    return (
      <div className="glass-card p-6 mb-6">
        <div className="flex items-center mb-6">
          <div className="w-10 h-10 rounded-xl icon-gradient-indigo-violet flex items-center justify-center mr-3">
            <i className="bx bx-filter-alt text-white text-xl"></i>
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-800">
              Filter Orang Tua per Rombel
            </h2>
            <p className="text-sm text-gray-500">
              Saring data orang tua berdasarkan periode & rombel
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Tahun Ajaran */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                1
              </span>
              Tahun Ajaran
            </label>
            <Select
              styles={selectStyles}
              isClearable
              options={this.state.data_tahun_ajaran}
              value={
                this.state.tahun_ajaran_search
                  ? {
                      value: this.state.tahun_ajaran_search,
                      label: this.state.tahun_ajaran_search,
                    }
                  : null
              }
              onChange={this.filterTahunAjaran}
              placeholder="Pilih Tahun Ajaran"
              isLoading={this.state.loadingFilter}
            />
          </div>

          {/* Kurikulum */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
                  this.state.tahun_ajaran_search
                    ? "bg-indigo-100 text-indigo-600"
                    : "bg-gray-100 text-gray-400"
                } text-xs font-bold mr-2`}
              >
                2
              </span>
              Jenis Kurikulum
            </label>
            <Select
              styles={selectStyles}
              isClearable
              options={dataKurikulum}
              value={
                this.state.filterKurikulumSearch
                  ? {
                      value: this.state.filterKurikulumSearch,
                      label: this.state.filterKurikulumSearch.toUpperCase(),
                    }
                  : null
              }
              onChange={this.filterKurikulum}
              placeholder={
                this.state.tahun_ajaran_search
                  ? "Pilih Kurikulum"
                  : "Pilih Tahun Ajaran dulu"
              }
              isDisabled={!this.state.tahun_ajaran_search}
            />
          </div>

          {/* Kelas */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
                  this.state.filterKurikulumSearch
                    ? "bg-indigo-100 text-indigo-600"
                    : "bg-gray-100 text-gray-400"
                } text-xs font-bold mr-2`}
              >
                3
              </span>
              Kelas
            </label>
            <Select
              styles={selectStyles}
              isClearable
              options={this.state.data_kelas}
              value={
                this.state.kelas_search
                  ? {
                      value: this.state.kelas_search,
                      label: this.state.kelas_search,
                    }
                  : null
              }
              onChange={this.filterKelas}
              placeholder={
                this.state.filterKurikulumSearch
                  ? "Pilih Kelas"
                  : "Pilih Kurikulum dulu"
              }
              isDisabled={!this.state.filterKurikulumSearch}
            />
          </div>

          {/* Peminatan - SMA */}
          {String(this.state.jenjang_id_select) === "4" && (
            <div className="filter-group">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <span
                  className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
                    this.state.kelas_search
                      ? "bg-indigo-100 text-indigo-600"
                      : "bg-gray-100 text-gray-400"
                  } text-xs font-bold mr-2`}
                >
                  4
                </span>
                Peminatan
              </label>
              <Select
                styles={selectStyles}
                isClearable
                options={this.state.data_peminatan}
                value={
                  this.state.peminatan_search
                    ? {
                        value: this.state.peminatan_search,
                        label:
                          this.state.peminatan_search_label ||
                          this.state.peminatan_search,
                      }
                    : null
                }
                onChange={this.filterPeminatan}
                placeholder={
                  this.state.kelas_search
                    ? "Pilih Peminatan"
                    : "Pilih Kelas dulu"
                }
                isLoading={this.state.loading_peminatan}
                isDisabled={!this.state.kelas_search}
              />
            </div>
          )}

          {/* SMK - Bidang, Program, Kompetensi */}
          {String(this.state.jenjang_id_select) === "5" &&
            this.renderSMKFilters()}

          {/* Rombel - opsional, mempersempit sampai satu rombel spesifik */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
                  this.state.kelas_search
                    ? "bg-green-100 text-green-600"
                    : "bg-gray-100 text-gray-400"
                } text-xs font-bold mr-2`}
              >
                5
              </span>
              Rombel (opsional)
            </label>
            <Select
              styles={selectStyles}
              isClearable
              options={this.state.data_rombel}
              value={
                this.state.rombel_search
                  ? {
                      value: this.state.rombel_search,
                      label: this.state.rombel_search_label,
                    }
                  : null
              }
              onChange={this.filterRombel}
              placeholder={
                this.state.kelas_search ? "Pilih Rombel" : "Pilih Kelas dulu"
              }
              isLoading={this.state.loading_rombel}
              isDisabled={!this.state.kelas_search}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-6 flex justify-center gap-3">
          <button
            className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-all duration-200 flex items-center"
            onClick={this.resetFilters}
          >
            <i className="bx bx-reset text-xl mr-2"></i>
            Reset Filter
          </button>
          <button
            className={`px-8 py-3 ${
              anyFilterSelected
                ? "btn-gradient-indigo hover:shadow-xl transform hover:-translate-y-0.5"
                : "bg-gray-300 cursor-not-allowed"
            } text-white font-semibold rounded-xl shadow-lg transition-all duration-200 flex items-center`}
            onClick={this.setFilter}
            disabled={this.state.loadingSearch}
          >
            <i className="bx bx-search-alt-2 text-xl mr-2"></i>
            {this.state.loadingSearch ? "Mencari..." : "Cari"}
          </button>
        </div>
      </div>
    );
  }

  renderSMKFilters() {
    return (
      <>
        {/* Bidang */}
        <div className="filter-group">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
              4a
            </span>
            Bidang Keahlian
          </label>
          <Select
            styles={selectStyles}
            options={this.state.data_bidang}
            value={
              this.state.bidang_search
                ? {
                    value: this.state.bidang_search,
                    label:
                      this.state.bidang_search_label ||
                      this.state.bidang_search,
                  }
                : null
            }
            onChange={this.filterBidang}
            placeholder="Pilih Bidang"
            isLoading={this.state.loading_bidang}
            isClearable
          />
        </div>

        {/* Program */}
        {this.state.bidang_search && (
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                4b
              </span>
              Program Keahlian
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_program}
              value={
                this.state.program_search
                  ? {
                      value: this.state.program_search,
                      label:
                        this.state.program_search_label ||
                        this.state.program_search,
                    }
                  : null
              }
              onChange={this.filterProgram}
              placeholder="Pilih Program"
              isLoading={this.state.loading_program}
              isClearable
            />
          </div>
        )}

        {/* Kompetensi - hanya untuk K13 */}
        {this.state.program_search &&
          this.state.filterKurikulumSearch === "k13" && (
            <div className="filter-group">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                  4c
                </span>
                Kompetensi Keahlian
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_kompetensi}
                value={
                  this.state.kompetensi_search
                    ? {
                        value: this.state.kompetensi_search,
                        label:
                          this.state.kompetensi_search_label ||
                          this.state.kompetensi_search,
                      }
                    : null
                }
                onChange={this.filterKompetensi}
                placeholder="Pilih Kompetensi"
                isLoading={this.state.loading_kompetensi}
                isClearable
              />
            </div>
          )}
      </>
    );
  }

  // ============ RENDER: TABLE ============
  showData() {
    return (
      <div className="px-1 py-1">
        <DataTable
          ref={(dt) => {
            this.dt = dt;
          }}
          action={{
            aksi: (col, data) => {
              var button = (
                <button className="flex btn-blue text-sm text-white px-4 py-2 rounded-full items-center">
                  Detail
                </button>
              );
              return button;
            },

            username: (col, data) => {
              if (col.username !== null) {
                return <p className="text-sm">{col.username}</p>;
              } else {
                return <p className="text-sm">-</p>;
              }
            },
          }}
          url={this.state.url_show_data}
          columns={[
            {
              index: "tahun_ajaran",
              label: "TAHUN AJARAN",
            },
            {
              index: "kurikulum",
              label: "KURIKULUM",
            },
            {
              index: "nama_siswa",
              label: "NAMA SISWA",
            },
            {
              index: "kelas",
              label: "KELAS",
            },
            {
              index: "nama_spektrum",
              label: "PEMINATAN",
            },
            {
              index: "nama_rombel",
              label: "ROMBEL",
            },
            {
              index: "username",
              label: "USERNAME",
            },
            {
              index: "jenis_orangtua",
              label: "Jenis Orangtua",
            },
            {
              index: "nama_orangtua",
              label: "NAMA ORANG TUA / WALI",
            },
            {
              index: "no_handphone",
              label: "NO HP",
            },
          ]}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        <SweetAlert
          show={this.state.show_alert}
          title={this.state.title_alert}
          text={this.state.message_alert}
          type={this.state.icon_alert}
          onConfirm={() => this.setState({ show_alert: false })}
          onOutsideClick={() => this.setState({ show_alert: false })}
        />

        <div className="shadow-md mx-auto py-3 mt-6 rounded-lg bg-white sm-container border">
          <div className="bg-white flex justify-between items-center mt-2 px-6 pb-2">
            <h1 className="text-xl text-gray-800 font-extrabold">
              Orang Tua Per Rombongan Belajar
              <span className="text-gray-500 font-thin block text-sm">
                Daftar Orang Tua per Rombongan Belajar.
              </span>
            </h1>
          </div>
        </div>

        <div className="sm-container mx-auto mt-2">
          {this.state.loadingFilter ? (
            <div className="glass-card p-8">
              <div className="flex flex-col items-center justify-center">
                <Skeleton width={200} height={20} className="mb-4" />
                <Skeleton width={300} height={40} className="mb-2" />
                <Skeleton width={300} height={40} className="mb-2" />
                <Skeleton width={300} height={40} />
              </div>
            </div>
          ) : (
            this.renderFilterPanel()
          )}

          <div className="mb-6">
            <input
              type="search"
              className="w-full md:w-1/3 pl-4 pr-4 py-2 rounded-full border border-gray-300 focus:outline-none focus:border-indigo-400 text-gray-800"
              placeholder="Cari nama siswa, username"
              id="search"
              value={this.state.searchText}
              onChange={this.handleSearch}
            />
          </div>
        </div>

        <div className="shadow-md mx-auto py-3 mt-2 rounded-lg bg-white sm-container border">
          {this.showData()}
        </div>
      </div>
    );
  }
}